import { component, prop } from '../../../decorators';

import { scrollIntoViewIfNeeded } from '../../../components/common/utils';

import Ellipsis from '../../../components/common/ellipsis/ellipsis.vue';

const SKIP_INFO_TIME = 120000; // ms

@component({
   components: { current: 'scrollToMeIfNeeded', Ellipsis }
})
export default class VideoItem {
   @prop({ type: Object, required: true }) info
   @prop({ type: Boolean, default: false }) current
   @prop({ type: Boolean, required: false }) isClip

   get duration() {
      return this.isClip ? this.info.tcOut - this.info.tcIn : this.info.duration - SKIP_INFO_TIME;
   }

   scrollToMeIfNeeded() {
      if ( this.current ) {
         scrollIntoViewIfNeeded(this.$el);
      }
   }

   mounted() {
      this.scrollToMeIfNeeded();
   }
}
